import { Skeleton } from "ant-design-vue";
const { ...other } = Skeleton;
const YwSkeleton = {
	...other,
	name: "YwSkeleton",
};

YwSkeleton.install = function (Vue) {
	Vue.component(YwSkeleton.name, Skeleton);
};

export default YwSkeleton;
